import { createStore as l } from "zustand";
import { NetworkStatus as u } from "../../networkStatus.mjs";
import { deduplicateItems as i, sortItems as c } from "./utils.mjs";
function m(e) {
  const t = i(e);
  return c(t);
}
const p = {
  shouldSetPage: !0,
  shouldAppend: !1
}, d = {
  items: [],
  metadata: {
    total_count: 0,
    unread_count: 0,
    unseen_count: 0
  },
  pageInfo: {
    before: null,
    after: null,
    page_size: 50
  }
};
function I() {
  return l()((e) => ({
    // Keeps track of all of the items loaded
    ...d,
    // The network status indicates what's happening with the request
    networkStatus: u.ready,
    loading: !1,
    setNetworkStatus: (t) => e(() => ({
      networkStatus: t,
      loading: t === u.loading
    })),
    setResult: ({ entries: t, meta: s, page_info: n }, a = p) => e((o) => ({
      items: a.shouldAppend ? m(o.items.concat(t)) : t,
      metadata: s,
      pageInfo: a.shouldSetPage ? n : o.pageInfo,
      loading: !1,
      networkStatus: u.ready
    })),
    setMetadata: (t) => e(() => ({ metadata: t })),
    resetStore: (t = d.metadata) => e(() => ({ ...d, metadata: t })),
    setItemAttrs: (t, s) => {
      const n = t.reduce(
        (a, o) => ({ ...a, [o]: s }),
        {}
      );
      return e((a) => ({ items: a.items.map((r) => n[r.id] ? { ...r, ...n[r.id] } : r) }));
    }
  }));
}
export {
  I as default
};
//# sourceMappingURL=store.mjs.map
